import * as Yup from "yup"
import { AcademicLevel, Email, FirstName, LastName, MobilePhoneRequired, Salutation, Consentement } from "services/validation"

const schema = Yup.object().shape({
  ...Consentement,
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
    ...Salutation
  })
})

export default schema
